<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { BpBusinessHourInterval } from '~/definitions/AllDefinitions'

interface BusinessHoursInterface {
  days: BpBusinessHourInterval[]
}

withDefaults(defineProps<BusinessHoursInterface>(), {
  days: () => [
    {
      today: false,
      day: 'MON',
      type: 'time_interval',
      hours: [],
      formattedHours: [],
    },
  ],
})
const { t } = useI18n()
function fullDayName(day: string) {
  switch (day) {
    case 'MON':
      return 'MONDAY'
    case 'TUE':
      return 'TUESDAY'
    case 'WED':
      return 'WEDNESDAY'
    case 'THU':
      return 'THURSDAY'
    case 'FRI':
      return 'FRIDAY'
    case 'SAT':
      return 'SATURDAY'
    case 'SUN':
      return 'SUNDAY'
    default:
      return day.toUpperCase()
  }
}
function formattedHour(interval: BpBusinessHourInterval) {
  if (interval.type === 'twenty_four_hours') {
    return t('TWENTY_FOUR_HOURS')
  } else if (interval.type === 'CLOSED') {
    return t('CLOSED')
  } else {
    let ret = ''
    interval.formattedHours.forEach((val, key) => {
      if (key > 0) {
        ret += ' | '
      }
      ret += `${val.from} - ${val.to}`
    })
    return ret
  }
}
</script>

<template>
  <div class="w-full text-tw-1">
    <div
      v-if="days.length"
      class="w-full"
    >
      <div
        v-for="(hour, key) in days"
        :key="hour.day"
        :class="{
          'font-medium': key === 0,
          'text-rose-600': hour.type === 'closed',
        }"
        class="w-full flex flex-row justify-between items-center"
      >
        <div class="mr-5">
          {{ t(fullDayName(hour.day)) }}
        </div>
        <div v-if="hour.type !== 'closed'">
          {{ formattedHour(hour) }}
        </div>
        <div v-else>
          {{ t('CLOSED') }}
        </div>
      </div>
    </div>
  </div>
</template>
